import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=6be0a806&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=6be0a806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0a806",
  null
  
)

export default component.exports